import { connect } from "react-redux"
import { compose } from "redux"
import StatisticsPageTheme from "../components/statistics-page-theme"
import { getVariables } from "../utilities/route"
import { withData } from "../decorators/with-data"
import gql from "graphql-tag"
import { withTranslations } from "../decorators/with-translations"
import { setSubmitError, setSortingType, setSortAscending, setFilters } from '../actions/survey'
import { QUESTIONNAIRE_FRAGMENT, SURVEY_LIST_PARAMETER_FRAGMENT, SURVEY_TREE_PARAMETER_FRAGMENT } from "../graphql/fragments"
import { YOU_FILTER, toNormalizedRespondentFilters } from '../utilities/helpers'
import { withImprovementProjectData } from './withImprovementProjectData'

const paramsQuery = gql`
  query FinishPage(
    $surveyId: UUID!
    $languageCode: String
  ) {
    questionnaire(languageCode: $languageCode) {
      ...QuestionnaireFragment
    }
    respondentParameters(
      surveyId: $surveyId
      languageCode: $languageCode
    ) {
      ...SurveyListParameter
      ...SurveyTreeParameter
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
  ${SURVEY_LIST_PARAMETER_FRAGMENT}
  ${SURVEY_TREE_PARAMETER_FRAGMENT}
`;

const statsQuery = gql`
  query FinishPageParameterDetails(
    $surveyId: UUID!
    $catalystId: UUID!
    $respondentFilters: [RespondentFilterInput!]
    $languageCode: String
  ) {
    surveyStatistics(
      surveyId: $surveyId
      respondentFilters: $respondentFilters
      languageCode: $languageCode
    ) {
      __typename
      ... on SurveyStatisticsOutput {
        overallAggregatedResponse,
        themes {
          id
          aggregatedResponse
        }
        drivers {
          id
          aggregatedResponse
          aggregatedImportance
        }
        questions {
          id
          aggregatedResponse
          aggregatedImportance
          totalRespondentCount
          skippedRespondentCount
        }
      }
    }
    afterGameDetailedOpenQuestionsStatistics (
      surveyId: $surveyId
      catalystId: $catalystId
      respondentFilters: $respondentFilters
      languageCode: $languageCode
    ) {
      id
      answers {
        answer
        public
      }
    }
  }
`;

const mapStateToProps = ({ survey: { submitError, filters, sortingType, sortAscending } }) => {
  return {
    submitError,
    filters,
    sortingType,
    sortAscending,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onSubmitError: (error) => {
      dispatch(setSubmitError(error));
    },
    onSetFilters: filters => {
      dispatch(setFilters(filters))
    },
    onSetSortingType: (type) => {
      dispatch(setSortingType(type));
    },
    onSetSortAscending: (ascending) => {
      dispatch(setSortAscending(ascending));
    }
  };
};

export default compose(
  withTranslations,
  connect(mapStateToProps, mapDispatchToProps),
  withData(paramsQuery, {
    options: (props) => {
      return {
        ...getVariables(props),
        fetchPolicy: "network-only",
      };
    },
  }),
  withData(statsQuery, {
    options: (props) => {
      const variables = { ...getVariables(props) };

      if (props.questionnaire.isAfterGameGuest || props.questionnaire.canViewAfterGame) {
        // Aftergame
        props.onSetFilters(props.filters ? props.filters : []);
        variables.variables.respondentFilters = toNormalizedRespondentFilters(props.filters);
      } else {
        // Before aftergame always "You" filter
        props.onSetFilters(YOU_FILTER);
        variables.variables.respondentFilters = YOU_FILTER;
      }
      return {
        ...variables,
        fetchPolicy: "network-only",
      };
    },
  }),
  withImprovementProjectData,
)(StatisticsPageTheme)



// WEBPACK FOOTER //
// ./src/containers/statistics-page-theme.js